(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents !== 'number') {
      cents = parseInt(cents, 10) || 0;
    }
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var dollars = (cents / 100).toFixed(2);
    return '€' + dollars.replace('.', ',');
  }

  function initPersonalizationModal(modalEl) {
    if (!modalEl || modalEl.dataset.initialized === 'true') return;
    modalEl.dataset.initialized = 'true';

    var sectionId = modalEl.dataset.sectionId;
    var basePriceCents = parseInt(modalEl.dataset.basePrice, 10) || 0;
    var currentMainVariantId = modalEl.dataset.mainVariantId || null;

    var totalEl = modalEl.querySelector('.js-personalization-total-price');
    var addonsTotalEl = modalEl.querySelector('.js-personalization-addons-price');
    var submitBtn = modalEl.querySelector('.js-personalization-submit');
    var spinner = submitBtn ? submitBtn.querySelector('.spinner-border') : null;
    var btnText = submitBtn ? submitBtn.querySelector('.btn-text') : null;
    var variantTitleEl = modalEl.querySelector('.js-main-variant-title');
    var basePriceDisplayEl = modalEl.querySelector('.personalization-base-price');

    function getMainProductInfo() {
      var selectEl = document.querySelector('#ProductSelect-' + sectionId) ||
                     document.querySelector('#AddToCartForm-' + sectionId + ' [name="id"]') ||
                     document.querySelector('select[name="id"]');
      
      var variantId = currentMainVariantId;
      var price = basePriceCents;
      var variantTitle = modalEl.dataset.mainVariantTitle || '';

      if (selectEl && selectEl.value) {
        variantId = selectEl.value;
        var selectedOpt = selectEl.options ? selectEl.options[selectEl.selectedIndex] : null;
        if (selectedOpt) {
          if (selectedOpt.dataset.price) {
            price = parseInt(selectedOpt.dataset.price, 10) || price;
          }
          if (selectedOpt.text && selectedOpt.text.indexOf(' - ') !== -1) {
            variantTitle = selectedOpt.text.split(' - ')[0];
          }
        }
      }

      var qtyInput = document.querySelector('#AddToCartForm-' + sectionId + ' [name="quantity"]') ||
                     document.querySelector('#Quantity');
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      return {
        variantId: variantId,
        price: price,
        variantTitle: variantTitle,
        quantity: quantity
      };
    }

    // Update dynamic pricing
    function recalculateTotal() {
      var mainInfo = getMainProductInfo();
      var currentBase = mainInfo.price;

      if (basePriceDisplayEl) {
        basePriceDisplayEl.textContent = formatMoney(currentBase);
      }
      if (variantTitleEl && mainInfo.variantTitle) {
        variantTitleEl.textContent = mainInfo.variantTitle;
      }

      var addonsCents = 0;
      var cards = modalEl.querySelectorAll('.personalization-addon-card');

      cards.forEach(function (card) {
        var checkbox = card.querySelector('.js-addon-checkbox');
        var variantSelect = card.querySelector('.js-addon-variant-select');

        if (checkbox && checkbox.checked) {
          card.classList.add('is-selected');
          var itemPrice = 0;

          if (variantSelect) {
            var selectedVarOpt = variantSelect.options[variantSelect.selectedIndex];
            itemPrice = parseInt(selectedVarOpt.dataset.price, 10) || 0;
          } else if (checkbox.dataset.price) {
            itemPrice = parseInt(checkbox.dataset.price, 10) || 0;
          }

          addonsCents += itemPrice;
        } else {
          card.classList.remove('is-selected');
        }
      });

      var grandTotal = currentBase + addonsCents;

      if (addonsTotalEl) {
        addonsTotalEl.textContent = formatMoney(addonsCents);
      }
      if (totalEl) {
        totalEl.textContent = formatMoney(grandTotal);
      }
    }

    // Sync when PDP variant changes
    if (window.jQuery) {
      window.jQuery(document).on('variantChange', function (e) {
        if (e.variant) {
          currentMainVariantId = e.variant.id;
          basePriceCents = e.variant.price;
          modalEl.dataset.basePrice = e.variant.price;
          modalEl.dataset.mainVariantId = e.variant.id;
          modalEl.dataset.mainVariantTitle = e.variant.title;
          modalEl.dataset.mainVariantAvailable = e.variant.available ? 'true' : 'false';

          if (submitBtn) {
            if (e.variant.available) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('btn--sold-out');
              if (btnText) btnText.textContent = 'Nu kopen';
            } else {
              submitBtn.disabled = true;
              submitBtn.classList.add('btn--sold-out');
              var soldOutText = (window.theme && window.theme.strings && window.theme.strings.soldOut) ? window.theme.strings.soldOut : 'Uitverkocht';
              if (btnText) btnText.textContent = soldOutText;
            }
          }

          recalculateTotal();
        }
      });

      // Recalculate when modal opens
      window.jQuery(modalEl).on('show.bs.modal', function () {
        if (modalEl.dataset.mainVariantAvailable === 'false') {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.classList.add('btn--sold-out');
            var soldOutText = (window.theme && window.theme.strings && window.theme.strings.soldOut) ? window.theme.strings.soldOut : 'Uitverkocht';
            if (btnText) btnText.textContent = soldOutText;
          }
        }
        recalculateTotal();
      });
    }

    // Toggle card selection on click
    modalEl.addEventListener('click', function (e) {
      var card = e.target.closest('.personalization-addon-card');
      if (card && !e.target.classList.contains('js-addon-variant-select')) {
        var checkbox = card.querySelector('.js-addon-checkbox');
        if (checkbox && e.target !== checkbox) {
          checkbox.checked = !checkbox.checked;
          recalculateTotal();
        }
      }
    });

    // Recalculate on checkbox or variant change
    modalEl.addEventListener('change', function (e) {
      if (e.target.classList.contains('js-addon-checkbox') || e.target.classList.contains('js-addon-variant-select')) {
        recalculateTotal();
      }
    });

    // Bundle Submit to Shopify Ajax Cart API
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();

        var mainInfo = getMainProductInfo();
        var mainVariantId = mainInfo.variantId;

        if (!mainVariantId) {
          alert('Please select a product variant before adding to cart.');
          return;
        }

        if (modalEl.dataset.mainVariantAvailable === 'false') {
          var soldOutMsg = (window.theme && window.theme.strings && window.theme.strings.soldOut) ? window.theme.strings.soldOut : 'Uitverkocht';
          alert(soldOutMsg);
          return;
        }

        // Show spinner & disable button
        if (spinner) spinner.classList.remove('d-none');
        if (btnText) btnText.textContent = 'Adding to Cart...';
        submitBtn.disabled = true;

        var items = [
          {
            id: parseInt(mainVariantId, 10),
            quantity: mainInfo.quantity
          }
        ];

        // Gather checked add-ons
        var cards = modalEl.querySelectorAll('.personalization-addon-card');
        cards.forEach(function (card) {
          var checkbox = card.querySelector('.js-addon-checkbox');
          if (checkbox && checkbox.checked) {
            var selectedVarId = checkbox.dataset.variantId;
            var variantSelect = card.querySelector('.js-addon-variant-select');
            if (variantSelect) {
              selectedVarId = variantSelect.value;
            }

            if (selectedVarId) {
              items.push({
                id: parseInt(selectedVarId, 10),
                quantity: 1
              });
            }
          }
        });

        // Function to refresh and open the mini cart drawer
        function onCartSuccess() {
          // Reset spinner & button
          if (spinner) spinner.classList.add('d-none');
          if (btnText) btnText.textContent = 'Add to Cart';
          submitBtn.disabled = false;

          // Hide Modal using Bootstrap Modal or jQuery
          if (window.jQuery && window.jQuery(modalEl).modal) {
            window.jQuery(modalEl).modal('hide');
          } else {
            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            document.body.classList.remove('modal-open');
            var backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
          }

          // Re-generate and update mini-cart drawer
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.generateCart();
            window.theme.miniCart.updateElements();
          }

          // Slide open the cart drawer
          if (window.jQuery) {
            window.jQuery('.js-mini-cart').addClass('active');
          } else {
            var miniCartEl = document.querySelector('.js-mini-cart');
            if (miniCartEl) miniCartEl.classList.add('active');
          }
        }

        function onCartError(errorMsg) {
          if (spinner) spinner.classList.add('d-none');
          if (btnText) btnText.textContent = 'Add to Cart';
          submitBtn.disabled = false;
          alert(errorMsg || 'There was an issue adding your items to the cart. Please try again.');
        }

        // Use jQuery.ajax if available (theme native), fallback to fetch
        if (window.jQuery) {
          window.jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            contentType: 'application/json',
            dataType: 'json',
            success: function () {
              onCartSuccess();
            },
            error: function (xhr) {
              var msg = 'Failed to add items to cart.';
              if (xhr.responseJSON && xhr.responseJSON.description) {
                msg = xhr.responseJSON.description;
              }
              onCartError(msg);
            }
          });
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw new Error(err.description || 'Failed to add items');
                });
              }
              return res.json();
            })
            .then(function () {
              onCartSuccess();
            })
            .catch(function (err) {
              onCartError(err.message);
            });
        }
      });
    }

    // Initial price calculation
    recalculateTotal();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modals = document.querySelectorAll('.personalization-modal');
    modals.forEach(initPersonalizationModal);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var modal = e.target.querySelector('.personalization-modal');
      if (modal) initPersonalizationModal(modal);
    });
  }
})();
